import { getLang, type Lang, t } from '@shared/i18n';
import { Link, Outlet } from 'react-router-dom';
import { useAuth } from '../auth';
import { CONTACT_EMAIL, PUBLISHER } from '../config';
import { chooseLang } from '../lang';

/** Petit sélecteur « FR | EN » : la langue active en gras et en rouge. */
function LangSwitch() {
  const current = getLang();
  const option = (lang: Lang, label: string) => (
    <button
      type="button"
      className={current === lang ? 'active' : ''}
      aria-pressed={current === lang}
      onClick={() => current !== lang && chooseLang(lang)}
    >
      {label}
    </button>
  );
  return (
    <span className="lang-switch" role="group" aria-label={t('Langue', 'Language')}>
      {option('fr', 'FR')}|{option('en', 'EN')}
    </span>
  );
}

export function Layout() {
  const { isStaff } = useAuth();
  return (
    <>
      <header className="site-header">
        <div className="container">
          <Link to="/" className="brand">
            <span className="logo">FM</span>
            FollowMe
          </Link>
          <nav className="nav">
            <Link to="/assistance" className="hide-mobile">
              {t('Assistance', 'Support')}
            </Link>
            <Link to="/confidentialite" className="hide-mobile">
              {t('Confidentialité', 'Privacy')}
            </Link>
            <LangSwitch />
            <Link to={isStaff ? '/organisateur' : '/organisateur/connexion'} className="btn small">
              {t('Espace organisateur', 'Organiser area')}
            </Link>
          </nav>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
      <footer className="site-footer">
        <div className="container">
          <div className="links">
            <Link to="/">{t('Accueil', 'Home')}</Link>
            <Link to="/assistance">{t('Assistance', 'Support')}</Link>
            <Link to="/confidentialite">{t('Politique de confidentialité', 'Privacy policy')}</Link>
            <Link to="/suppression-compte">{t('Supprimer son compte', 'Delete your account')}</Link>
            <Link to="/mentions-legales">{t('Mentions légales', 'Legal notice')}</Link>
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
          </div>
          © {new Date().getFullYear()} FollowMe — {PUBLISHER}
        </div>
      </footer>
    </>
  );
}
